'use client'
import { CopyWrapper } from "@/components/CopyWrapper"
import { DarkButton } from "@/ui/Button"
import { Input, Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@heroui/react"
import { useTranslations } from "next-intl"
import { createContext, PropsWithChildren, ReactNode, useContext, useState } from "react"

type ShareContextType = {
  share: (params: {
    url?: string
    title?: string
    message?: string
    notice?: ReactNode
  }) => void
}

const ShareContext = createContext<ShareContextType>(null!)

export const ShareProvider = ({ children }: PropsWithChildren) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const t = useTranslations()


  const [shareUrl, setUrl] = useState('')
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [notice, setNotice] = useState<ReactNode>(null!)



  const share: ShareContextType['share'] = ({ url = location.href, title, message, notice = null, }) => {
    setUrl(url)
    setTitle(title || '')
    setMessage(message || '')
    setNotice(notice)
    onOpen()
  }

  return (
    <>
      <ShareContext.Provider value={{ share }}>
        {children}
      </ShareContext.Provider>

      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        classNames={{
          base: "max-w-[512px] p-[32px]"
        }}
        hideCloseButton
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader
                className="p-0 justify-between text-[20px] text-theme-primary"
              >
                <span>{title || `${t('common.share')} ${t('common.character')}`}</span>
              </ModalHeader>
              <ModalBody className="p-0 mt-[20px] max-h-[340px]">
                <p className="text-theme-primary/70 text-[16px]">
                  {message || "You can share the link with friends."}
                </p>

                <div className="flex items-end mt-[10px] gap-[8px] pt-[4px]">
                  <Input
                    label=""
                    classNames={{
                      inputWrapper: "bg-theme-primary/5",
                      input: "!text-theme-primary/70",
                      label: "top-[18px]"
                    }}
                    radius="sm"
                    value={shareUrl}
                    labelPlacement="outside"
                  />
                  <CopyWrapper render={(copy) => (<DarkButton className="rounded-[8px] px-[22px]" onPress={() => {
                    copy(shareUrl!)
                  }}
                  >Copy Link</DarkButton>)} />
                </div>

                <p className="text-[13px] text-center text-theme-error">
                  {notice}</p>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>

  )
}

export const useShare = () => {
  const context = useContext(ShareContext);
  if (!context) {
    throw new Error('useToast must be used within a ShareProvider');
  }
  return context;
};